module.exports = __webpack_public_path__ + "img/winerackdog31.966d2f11.jpg";